// Thin shim over @capacitor/haptics. Every function is a no-op when running
// in the regular browser PWA — `isNativePlatform()` is the single guard so
// web users never feel an unexpected `navigator.vibrate` call (Capacitor's
// web fallback would otherwise fire one). On native iOS/Android the calls
// delegate to the Haptics plugin and any error is swallowed: a haptic
// failure must never break gameplay.

import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNativePlatform } from './platform.js';

/** Light tactile tap — fired after a successful, non-erroneous digit entry. */
export function lightTap(): void {
  if (!isNativePlatform()) return;
  void Haptics.impact({ style: ImpactStyle.Light }).catch(() => undefined);
}

/** Medium bump — fired when the entered digit doesn't match the solution. */
export function errorBump(): void {
  if (!isNativePlatform()) return;
  void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => undefined);
}

/** Success notification pattern — fired once the puzzle is solved. */
export function winSuccess(): void {
  if (!isNativePlatform()) return;
  void Haptics.notification({ type: NotificationType.Success }).catch(() => undefined);
}
